var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-attachments-edit"},[_c('accessoryList',{ref:"fileLinkmanList",attrs:{"belongtoProjectId":_vm.form.id,"belongtoProjectName":_vm.form.typeName},on:{"update:addFileList":_vm.getAddFileList}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-081217d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/accessory/attachmentsEdit.vue
// module id = null
// module chunks = 